// extracted by mini-css-extract-plugin
module.exports = {"back":"buttons_back__ec2Fr"};